import { PulseLoader, ClipLoader, BeatLoader } from "react-spinners";
import { COLORS, SIZES } from "../util/constants";

/**
 * Componente de loading reutilizável
 * @param {object} props
 * @param {'pulse'|'clip'|'beat'} props.type - Tipo do loader (padrão: 'pulse')
 * @param {'small'|'medium'|'large'} props.size - Tamanho do loader (padrão: 'medium')
 * @param {string} props.color - Cor do loader (padrão: cor primária)
 * @param {string} props.height - Altura do container (padrão: 600px)
 * @param {boolean} props.fullScreen - Se deve ocupar tela inteira (padrão: false)
 * @param {string} props.className - Classes CSS adicionais
 * @param {object} props.style - Estilos inline adicionais
 */
const Loader = ({
  type = "pulse",
  size = "medium",
  color = COLORS.PRIMARY,
  height = SIZES.LOADER_HEIGHT,
  fullScreen = false,
  className = "",
  style = {},
}) => {
  const sizeMap = {
    small: 10,
    medium: 15,
    large: 20,
  };

  const loaderSize = sizeMap[size] || sizeMap.medium;

  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: fullScreen ? "100vh" : height,
    width: "100%",
    ...style,
  };

  const renderLoader = () => {
    switch (type) {
      case "clip":
        return <ClipLoader color={color} size={loaderSize} />;
      case "beat":
        return <BeatLoader color={color} size={loaderSize} />;
      case "pulse":
      default:
        return <PulseLoader color={color} size={loaderSize} />;
    }
  };

  return (
    <div
      className={`loader-container ${className}`}
      style={containerStyle}
    >
      {renderLoader()}
    </div>
  );
};

export default Loader;
